import { useContext, useState, useEffect, useCallback } from 'react';
import { ModalContext } from 'context/ModalContext';
import { ModalWrapper } from './ModalWrapper';
import { useWindowSize } from 'hooks';
import { MODAL_TYPES } from './constants';
import ShareVideo from './ModalContent/ShareVideo';
import CreateChannel from './ModalContent/CreateChannel';
import DatePicker from 'components/DatePicker';
import SelectPlaylist from './ModalContent/SelectPlaylist';
import CreatePlaylist from './ModalContent/CreatePlaylist';
import ChannelMember from './ModalContent/ChannelMember';
import Collection from './ModalContent/Collection';
import Profile from './ModalContent/Profile';
import ExternalSharing from './ModalContent/ExternalSharing';
import EditSpeakerProfile from './ModalContent/EditSpeakerProfile';
import ProfileImageUpload from './ModalContent/ProfileImageUpload';
import RemoveProfileImage from './ModalContent/RemoveProfileImage';
import ResourceLink from './ModalContent/ResourceLink';
import ResourceFile from './ModalContent/ResourceFile';
import RemoveResource from './ModalContent/RemoveResource';
import TrimSaveChanges from './ModalContent/TrimSaveChanges';
import TrimRevertChanges from './ModalContent/TrimRevertChanges';
import BackgroundUpload from './ModalContent/BackgroundUpload';
import BackgroundSaveChanges from './ModalContent/BackgroundSaveChanges';
import TrimAlert from './ModalContent/TrimAlert';
import ExternalPoll from './ModalContent/ExternalPoll';
import PollDisplay from './ModalContent/PollDisplay';
import PollSaveChanges from './ModalContent/PollSaveChanges';
import DuplicatedDisplayTime from './ModalContent/DuplicatedDisplayTime';
import ChannelMembers from './ModalContent/ChannelMembers';
import AddPeople from './ModalContent/AddPeople';
import RemoveChannelPeople from './ModalContent/RemoveChannelPeople';
import RemoveVideoShot from './ModalContent/RemoveVideoShot';
import DeleteVideo from './ModalContent/DeleteVideo';
import AddSpeaker from './ModalContent/AddSpeaker';
import ChapterSummary from './ModalContent/ChapterSummary';
import VideoStats from './ModalContent/VideoStats';

const Warning = (props: any) => {
  console.log('props', props);

  const { editingId, setEditingId, onCancel, onConfirm } = props;
  const handleCancel = () => {
    console.log('cancel');
    onCancel();
  };

  const handleProceed = () => {
    onConfirm();
    setEditingId(editingId);
  };

  return (
    <div className="transparent font-lato">
      <div className="relative border-x border-t bg-gray-bg-dark border-gray-300  bg-white pb-7 pt-9 px-7 w-screen md:w-[520px] md:min-h-[100px] rounded-t-lg">
        <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">Unsaved Changes</span>
        <div className="flex mb-5 items-center text-sm mt-4">
          <p>You will lose any unsaved changes to your {props.itemType} item.</p>
        </div>
        <div className="flex flex-col text-sm font-bold">
          <div className="ml-auto mr-3">
            <button
              type="button"
              className="peer-focus:block bg-gray-100 text-black px-4 py-2 mr-2 rounded-md"
              onClick={handleCancel}
            >
              Keep editing
            </button>
            <button
              type="button"
              className="peer-focus:block bg-[#0979b7] text-white px-4 py-2 mr-2 rounded-md"
              onClick={handleProceed}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const removeItem = (props: any) => {
  const { onCancel, onConfirm, modalMessage } = props;
  const handleCancel = () => {
    onCancel();
  };

  const handleProceed = () => {
    onConfirm();
  };

  return (
    <div className="transparent font-lato">
      <div className="relative border-x border-t bg-gray-bg-dark border-gray-300  bg-white pb-7 pt-9 px-7 w-screen md:w-[520px] md:min-h-[100px] rounded-t-lg">
        <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">{modalMessage.title}</span>
        <div className="flex mb-5 items-center text-sm mt-4">
          <p>{modalMessage.text}</p>
        </div>
        <div className="flex flex-col text-sm font-bold">
          <div className="ml-auto mr-3">
            <button
              type="button"
              className="peer-focus:block bg-gray-100 text-black px-4 py-2 mr-2 rounded-md"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="peer-focus:block bg-[#0979b7] text-white px-4 py-2 mr-2 rounded-md"
              onClick={handleProceed}
            >
              Confirm to delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const ModalContents = {
  [MODAL_TYPES.share_video]: ShareVideo,
  [MODAL_TYPES.create_channel]: CreateChannel,
  [MODAL_TYPES.select_playlist]: SelectPlaylist,
  [MODAL_TYPES.create_playlist]: CreatePlaylist,
  [MODAL_TYPES.date_picker]: DatePicker,
  [MODAL_TYPES.channel_member]: ChannelMember,
  [MODAL_TYPES.collection]: Collection,
  [MODAL_TYPES.profile]: Profile,
  [MODAL_TYPES.external_sharing]: ExternalSharing,
  [MODAL_TYPES.edit_speaker_profile]: EditSpeakerProfile,
  [MODAL_TYPES.profile_image_upload]: ProfileImageUpload,
  [MODAL_TYPES.remove_profile_image]: RemoveProfileImage,
  [MODAL_TYPES.resource_link]: ResourceLink,
  [MODAL_TYPES.resource_file]: ResourceFile,
  [MODAL_TYPES.remove_resource]: RemoveResource,
  [MODAL_TYPES.trim_save_changes]: TrimSaveChanges,
  [MODAL_TYPES.trim_alert]: TrimAlert,
  [MODAL_TYPES.trim_revert_changes]: TrimRevertChanges,
  [MODAL_TYPES.background_upload]: BackgroundUpload,
  [MODAL_TYPES.background_save_changes]: BackgroundSaveChanges,
  [MODAL_TYPES.external_polls]: ExternalPoll,
  [MODAL_TYPES.poll_display]: PollDisplay,
  [MODAL_TYPES.poll_save_changes]: PollSaveChanges,
  [MODAL_TYPES.duplicated_display_time]: DuplicatedDisplayTime,
  [MODAL_TYPES.channel_members]: ChannelMembers,
  [MODAL_TYPES.add_people]: AddPeople,
  [MODAL_TYPES.remove_channel_people]: RemoveChannelPeople,
  [MODAL_TYPES.remove_video_shot]: RemoveVideoShot,
  [MODAL_TYPES.delete_video]: DeleteVideo,
  [MODAL_TYPES.edit_summary]: Warning,
  [MODAL_TYPES.remove_summary]: removeItem,
  [MODAL_TYPES.add_speaker]: AddSpeaker,
  [MODAL_TYPES.chapter_summary]: ChapterSummary,
  [MODAL_TYPES.statistics]: VideoStats
};

const RootModal = () => {
  const { hideModal, props, active, componentId } = useContext(ModalContext);

  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [isClosing, setIsClosing] = useState<boolean>(false);
  const [allowClosing, handleAllowClosing] = useState<boolean>(true);

  const [width] = useWindowSize();

  useEffect(() => {
    if (width) {
      const wideScreen = width > 768;
      setIsMobile(!wideScreen);
    }
  }, [width]);

  const handleCloseModal = useCallback(() => {
    if (allowClosing) {
      setIsClosing(true);
      setIsClosing(false);
      if (hideModal) {
        hideModal();
      }
    }
  }, [hideModal, allowClosing]);

  const handleConfirm = useCallback(() => {
    if (props?.onConfirm) {
      props.onConfirm();
    }
    handleCloseModal();
  }, [props, handleCloseModal]);

  const Modal = ModalWrapper;
  const ModalContent = ModalContents[componentId] ? ModalContents[componentId] : null;

  return (
    <Modal
      onClose={handleCloseModal}
      isClosing={isClosing}
      active={active}
      animation={props?.animation}
      hideOverlay={!isMobile && props?.hiddenOverlay}
      showCloseButton={props?.showCloseButton}
      horizontal={props?.horizontal}
      vertical={props?.vertical}
    >
      {ModalContent ? (
        <ModalContent
          {...props}
          onConfirm={handleConfirm}
          onCancel={handleCloseModal}
          handleAllowClosing={handleAllowClosing}
        />
      ) : (
        <></>
      )}
    </Modal>
  );
};

export default RootModal;
